<template>
    
    <div class="j-label-root">
        <span v-if="required == true" class="j-required">*</span> <slot/>
    </div>

</template>

<script setup>
const props     = defineProps({
    required    : {
        type        : Boolean,
        default     : false,
    }
});
</script>